<template>
  <div
    id="inventTargetList"
    class="inventTargetList"
    v-if="
      nowProduct.fund &&
      nowProduct.fund[propName] &&
      nowProduct.fund[propName].length > 0
    "
  >
    <div
      class="inventTargetList__title mt_15"
      :style="`background-color:#${color};border:1px solid #${border}`"
    >
      <div class="inventTargetList__title--title mr_10">{{ this.name }}</div>
      <div class="inventTargetList__title--subtitle">
        {{
          isOnlyOne
            ? "最多可選擇一檔投資標的"
            : `1.投資比例需以${fund_rato}%為單位，且合計需為100%。 2.請注意，投資標的之收益分配或撥回資產頻率與條件皆有可能變動。`
        }}
      </div>
    </div>
    <div
      class="inventTargetList__head"
      :style="`background-color:#${color};border:1px solid #${border}`"
    >
      <div>基金代碼</div>
      <div>基金名稱與介紹<div v-if="isNAP" class="inventTargetList__title--subtitle--nap">(可長按網址打開連結)</div></div>
      <div>幣別</div>
      <div>風險等級</div>
      <div>適合<br />風險屬性</div>
      <div>投資比例</div>
      <div>撥回方式</div>
      <div>
        <div class="btn btn-default btn-sm px_2 pt_2" @click="deleteAll()">
          <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
        </div>
      </div>
    </div>
    <div
      class="inventTargetList__body"
      v-for="(target, index) in selectInvestmentTargets"
      :key="target.fund_id"
    >
      <div>{{ target.fund_id }}</div>
      <div class="mf-textWrap">
        {{ target.fund_c_name }}<br />
        <a
          :href="isBankUser ? target.fund_url2 : target.fund_url"
          target="_blank"
          >{{ isBankUser ? target.fund_url2 : target.fund_url }}</a
        >
      </div>
      <div>{{ target.curr }}</div>
      <div>{{ target.risk_lvl }}</div>
      <div>{{ target.kyc_risk_lvl }}</div>
      <div>
        <div class="d-flex align-items-center">
          <input
            type="text"
            maxlength="3"
            class="form-control mr_2"
            style="width: 4.5rem"
            :data-vv-name="target.fund_id"
            :class="{
              'is-invalid': errors.has(target.fund_id) && needShowError,
            }"
            v-validate.continues="`required|fund_proportion_${propName}`"
            @input="ageFormat(target, 'fund_proportion')"
            @blur="needShowError = false"
            v-model.trim="target.fund_proportion"
            :disabled="isOnlyOne"
          />
          %
        </div>
      </div>
      <!-- 撥回方式-->
      <div
        v-if="target.is_inv_dist === '1' && target.bou_type_opt_ind !== ''"
        class="d-flex align-items-center"
      >
        <select
          class="form-control mr_2"
          style="width: 16rem"
          data-vv-as="撥回方式"
          v-validate="`required`"
          data-vv-name="bou_type_opt_ind"
          v-model.trim="target.bou_type_opt_ind_value"
        >
          <option
            v-for="(item, index) in bou_type_list(target)"
            :key="index + 1"
            :value="item.paraval"
          >
            {{ item.paradetlno }}
          </option>
        </select>
      </div>
      <div v-else>
        {{
          target.is_inv_dist === "0" ? inv_dist_nm(target) : dist_type(target)
        }}
      </div>
      <div>
        <div class="btn btn-default btn-sm px_2 pt_2" @click="deleteOne(index)">
          <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import mf_Mixin from "@/desktop/views/mf/mixin";

export default {
  props: {
    selectInvestmentTargets: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: "基金配置",
    },
    propName: {
      type: String,
      default: "fund",
    },
    maxLength: {
      type: Number,
      default: 10,
    },
    color: {
      type: String,
      default: "E5F6EC",
    },
    border: {
      type: String,
      default: "53c480",
    },
    isOnlyOne: {
      type: Boolean,
      default: false,
    },
    validTotal100Text: {
      type: String,
      default: ""
    },
  },
  mixins: [mf_Mixin],
  data() {
    return {
      checkTotal100: false,
      needShowError: false,
      distTypeObj: {}, //this.$paragrpno.inv_dist_type 轉成 obj
      bouTypeObj: {}, // this.$paragrpno.bou_type_opt_ind 轉成 obj
      fund_rato: 5 //投資比重%數
    };
  },
  computed: {
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    nowProduct() {
      return this.MfEditing.mc_prod_list[0];
    },
    PRODUCT_FEATURE_DATA() {
      return this.MfEditing.mc_prod_list[0].FEATURE_DATA;
    },
    validTotal100() {
      return (
        this.selectInvestmentTargets.reduce((accumulator, currentObj) => {
          return accumulator + currentObj.fund_proportion * 1;
        }, 0) == 100
      );
    },
    isBankUser() {
      return this.$store.getters.IsBankUser;
    },
    isNAP() {
      return this.$store.state.userInfo.userType === "box" && !this.isBankUser;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      Validator.extend(`fund_proportion_${this.propName}`, {
        getMessage: "",
        validate: (value) => {
          this.selectInvestmentTargets.reduce((accumulator, currentObj) => {
            return accumulator + currentObj.fund_proportion * 1;
          }, 0);
          return (
            value % this.fund_rato == 0 &&
            value * 1 > 0 &&
            this.selectInvestmentTargets.reduce((accumulator, currentObj) => {
              return accumulator + currentObj.fund_proportion * 1;
            }, 0) == 100
          );
        },
      });

      /**
       * this.$paragrpno.inv_dist_type 轉成 obj
       * {paradetlno: "1",paraval: "現金"}
       */
      for (const item of this.$paragrpno.inv_dist_type) {
        this.distTypeObj[item.paraval] = item.paradetlno;
      }

      /**
       * this.$paragrpno.bou_type_opt_ind 轉成 obj
       * { paradetlno: "現金撥回",paraval: "1"}
       */
      for (const item of this.$paragrpno.bou_type_opt_ind) {
        this.bouTypeObj[item.paraval] = item.paradetlno;
      }

      let rato = this.PRODUCT_FEATURE_DATA.fund_rato ; //一般標的投資比重%數
      if(this.propName == 'fund_extra'){
        rato =  this.PRODUCT_FEATURE_DATA.fund_rate ; //永續標的投資比重%數
      }
      console.log(rato);
      this.fund_rato =  parseInt(rato) || 5; //預設5%
    },
    bou_type_list(target) {
      /**
       * bou_type_opt_ind 配息分配方式
       * 前端接收 target.bou_type_opt_ind 比對 後端參數選項值 this.$paragrpno.bou_type_opt_ind
       * 前端 target.bou_type_opt_ind==="1", 選項只有【現金撥回】
       * 前端 target.bou_type_opt_ind==="1，2", 選項【現金撥回、再購原標的】
       */
      let optionList = [];
      let bou_array = target.bou_type_opt_ind.split(",");
      // 當target.bou_type_opt_ind 長度只有1 , value為第一個數
      if (bou_array.length === 1) {
        target.bou_type_opt_ind_value = bou_array[0];
      }
      this.$paragrpno.bou_type_opt_ind.filter((item) => {
        bou_array.filter((element) => {
          if (element === item.paraval) {
            optionList.push(item);
          }
        });
      });
      return optionList;
    },
    dist_type(target) {
      /**
       * 收益分配或撥回資產 inv_dist_type
       * 前端接收 target.inv_dist_type 比對 後端參數選項值 this.$paragrpno.inv_dist_type
       */

      let detailName = "";
      // this.$paragrpno.inv_dist_type 是否有 target.inv_dist_type的參數，取出 option key
      let hasOptionKey = this.distTypeObj[target.inv_dist_type];
      if (hasOptionKey) {
        // 對應 this.$paragrpno.bou_type_opt_ind 選項詳細名稱
        detailName = this.bouTypeObj[hasOptionKey];
        target.bou_type_opt_ind_value = hasOptionKey;
      } else {
        detailName = target.inv_dist_type;
        target.bou_type_opt_ind_value = target.inv_dist_type;
      }
      return detailName;
    },
    inv_dist_nm(target) {
      let blankValue = "---";
      target.bou_type_opt_ind_value = blankValue;
      return blankValue;
    },
    deleteAll() {
      this.nowProduct.fund[this.propName] = [];
    },
    deleteOne(index) {
      this.nowProduct.fund[this.propName].splice(index, 1);
    },
    async validateAll() {
      this.needShowError = true;
      let valid = await this.$validator.validateAll();
      let validTotal100 = true;
      this.checkTotal100 = true;
      if (
        this.selectInvestmentTargets &&
        this.selectInvestmentTargets.length > 0
      ) {
        validTotal100 =
          this.selectInvestmentTargets.reduce((accumulator, currentObj) => {
            return accumulator + currentObj.fund_proportion * 1;
          }, 0) == 100;
      }
      if (
        this.selectInvestmentTargets.some((item) => {
          return !item.fund_proportion || item.fund_proportion == 0;
        })
      ) {
        this.$toast.info({
          title: "投資比例不得為空。",
        });
      }
      if (!validTotal100 || !valid) {
        this.$toast.info({
          title: this.validTotal100Text ||  `投資比例需以${this.fund_rato}%為單位，且合計需為100%! `,
        });
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.inventTargetList {
  max-width: 980px;
  &__title {
    width: 100%;
    height: 50px;
    padding: 0 15px;
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #53c480;
    background-color: #e5f6ec;
    display: flex;
    align-items: center;
    font-size: 16px;
    &--title {
      font-weight: 700;
      text-align: left;
      color: #323a45;
    }
    &--subtitle {
      font-size: 13px;
      text-align: left;
      color: #de4054;
      &--nap {
        font-size: 13px;
        text-align: center;
        color: #de4054;
      }
    }
  }
  &__head {
    font-weight: 700;
    width: 100%;
    height: 50px;
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #53c480;
    background-color: #e5f6ec;
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 16px;
    padding: 0 15px;
    & > div:nth-of-type(1) {
      width: 10%;
      text-align: left;
    }
    & > div:nth-of-type(2) {
      width: 30%;
    }
    & > div:nth-of-type(3) {
      flex: 1;
    }
    & > div:nth-of-type(4) {
      flex: 1;
    }
    & > div:nth-of-type(5) {
      flex: 1;
    }
    & > div:nth-of-type(6) {
      margin-right: 10px;
      padding-right: 20px;
      width: 13%;
    }
    & > div:nth-of-type(7) {
      padding-right: 20px;
      width: 15%;
    }
    & > div:nth-last-child(1) {
      width: 5%;
      text-align: right;
    }
  }
  &__body {
    display: flex;
    align-items: center;
    text-align: center;
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #c2c4c7;
    padding: 0 15px;

    &:nth-of-type(odd) {
      background-color: #f5f5f5;
    }
    & > div {
      padding: 6px 12px;
    }
    & > div:nth-of-type(1) {
      width: 10%;
      padding: 6px 0;
      text-align: left;
    }
    & > div:nth-of-type(2) {
      width: 30%;
      text-align: left;
      padding: 6px 20px;
    }
    & > div:nth-of-type(3) {
      flex: 1;
    }

    & > div:nth-of-type(4) {
      flex: 1;
    }
    & > div:nth-of-type(5) {
      flex: 1;
    }
    & > div:nth-of-type(6) {
      width: 12%;
    }
    & > div:nth-of-type(7) {
      width: 17%;
    }
    & > div:nth-last-child(1) {
      width: 5%;
      text-align: right;
    }
  }
}
</style>
